import script from "./DailyAgenda.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyAgenda.vue?vue&type=script&setup=true&lang=js"

import "./DailyAgenda.vue?vue&type=style&index=0&id=8def8c84&scoped=true&lang=css"
import "./DailyAgenda.vue?vue&type=style&index=1&id=8def8c84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8def8c84"]])

export default __exports__